var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-tabs',{on:{"click":_vm.tabClick},model:{value:(_vm.curCar),callback:function ($$v) {_vm.curCar=$$v},expression:"curCar"}},_vm._l((_vm.cars),function(itm,idx){return _c('van-tab',{key:idx,attrs:{"title":itm.name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }